module.exports = __webpack_public_path__ + "img/icon-sta2.79fba296.png";